import { Container } from './styles'
import reactIcon from '../../assets/react-icon.svg'
import linkedin from '../../assets/linkedin.svg'
import githubIcon from '../../assets/github.svg'
import whatsapp from '../../assets/whatsapp.svg'
import telegram from '../../assets/telegram.svg'
import instagramIcon from '../../assets/instagram.svg'
// import discordIcon from '../../assets/discord.png'
import Li from '../../assets/linkedin.svg'

export function Footer() {
  return (
    <Container className="footer">
      <a href="https://wikimedia.com" className="logo">
        <span>www.wikimedianet</span>
        <span>.com</span>
      </a>
      <div>
        <p>
          wikimedianet © All CopyRights Reserved 2024-2025 
          {/* <span>❤️</span> */}
        </p>
      </div>
      <div className="social-media">
    
        <a
          href="https://wa.me/919874821968"
          target="_blank"
          rel="noreferrer"
        >
          <img src={whatsapp} alt="Whatsapp" />
        </a>
        <a
          href="http://t.me/wikimedianet"
          target="_blank"
          rel="noreferrer"
        >
          <img src={telegram} alt="telegram" />
        </a>
         <a
          href="https://www.linkedin.com/in/wiki-medianet-966aa9307?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app "
          target="_blank"
          rel="noreferrer"
        >
          <img src={Li} alt="telegram" />
        </a>
        
      </div>
    </Container>
  )
}
